// colors/theme.js - KOMPLETT FARGE-SYSTEM MED ALLE NYANSER
export const colorThemes = {
  // Standard tema (rosa/lilla)
  default: {
    name: 'Standard',
    description: 'Rosa og lilla - elegant og feminin',
    colors: {
      primary: {
        50: '#fdf2f8',
        100: '#fce7f3',
        200: '#fbcfe8', 
        300: '#f9a8d4',
        400: '#f472b6',
        500: '#ec4899',  // Hovedfarge
        600: '#db2777',
        700: '#be185d',
        800: '#9d174d',
        900: '#831843'
      },
      secondary: {
        50: '#f8fafc',
        100: '#f1f5f9',
        200: '#e2e8f0',
        300: '#cbd5e1', 
        400: '#94a3b8',
        500: '#64748b',
        600: '#475569',
        700: '#334155',
        800: '#1e293b',
        900: '#0f172a'
      },
      accent: {
        50: '#f0f9ff',
        100: '#e0f2fe',
        200: '#bae6fd',
        300: '#7dd3fc',
        400: '#38bdf8',
        500: '#0ea5e9',
        600: '#0284c7',
        700: '#0369a1',
        800: '#075985',
        900: '#0c4a6e'
      },
      success: {
        50: '#f0fdf4',
        100: '#dcfce7',
        200: '#bbf7d0',
        300: '#86efac',
        400: '#4ade80',
        500: '#22c55e',
        600: '#16a34a',
        700: '#15803d',
        800: '#166534',
        900: '#14532d'
      },
      warning: {
        50: '#fffbeb',
        100: '#fef3c7',
        200: '#fde68a',
        300: '#fcd34d',
        400: '#fbbf24',
        500: '#f59e0b',
        600: '#d97706',
        700: '#b45309',
        800: '#92400e',
        900: '#78350f'
      },
      error: {
        50: '#fef2f2',
        100: '#fee2e2',
        200: '#fecaca',
        300: '#fca5a5',
        400: '#f87171',
        500: '#ef4444',
        600: '#dc2626',
        700: '#b91c1c',
        800: '#991b1b',
        900: '#7f1d1d'
      }
    }
  },

  // Tech tema (blå/turkis)
  tech: {
    name: 'Teknologi',
    description: 'Blå og turkis - moderne og profesjonell',
    colors: {
      primary: {
        50: '#eff6ff',
        100: '#dbeafe', 
        200: '#bfdbfe',
        300: '#93c5fd',
        400: '#60a5fa',
        500: '#3b82f6',  // Blå hovedfarge
        600: '#2563eb',
        700: '#1d4ed8',
        800: '#1e40af',
        900: '#1e3a8a'
      },
      secondary: {
        50: '#f8fafc',
        100: '#f1f5f9',
        200: '#e2e8f0',
        300: '#cbd5e1', 
        400: '#94a3b8',
        500: '#64748b',
        600: '#475569',
        700: '#334155',
        800: '#1e293b',
        900: '#0f172a'
      },
      accent: {
        50: '#f0fdfa',
        100: '#ccfbf1',
        200: '#99f6e4', 
        300: '#5eead4',
        400: '#2dd4bf',
        500: '#14b8a6',  // Turkis accent
        600: '#0d9488',
        700: '#0f766e',
        800: '#115e59',
        900: '#134e4a'
      },
      success: {
        50: '#f0fdf4',
        100: '#dcfce7',
        200: '#bbf7d0',
        300: '#86efac',
        400: '#4ade80',
        500: '#22c55e',
        600: '#16a34a',
        700: '#15803d',
        800: '#166534',
        900: '#14532d'
      },
      warning: {
        50: '#fffbeb',
        100: '#fef3c7',
        200: '#fde68a',
        300: '#fcd34d',
        400: '#fbbf24',
        500: '#f59e0b',
        600: '#d97706',
        700: '#b45309',
        800: '#92400e',
        900: '#78350f'
      },
      error: {
        50: '#fef2f2',
        100: '#fee2e2',
        200: '#fecaca',
        300: '#fca5a5',
        400: '#f87171',
        500: '#ef4444',
        600: '#dc2626',
        700: '#b91c1c',
        800: '#991b1b',
        900: '#7f1d1d'
      }
    }
  },

  // Nature tema (grønn/gul)
  nature: {
    name: 'Natur',
    description: 'Grønn og gul - frisk og organisk',
    colors: {
      primary: {
        50: '#f0fdf4',
        100: '#dcfce7',
        200: '#bbf7d0',
        300: '#86efac', 
        400: '#4ade80',
        500: '#22c55e',  // Grønn hovedfarge
        600: '#16a34a',
        700: '#15803d',
        800: '#166534',
        900: '#14532d'
      },
      secondary: {
        50: '#f8fafc',
        100: '#f1f5f9',
        200: '#e2e8f0',
        300: '#cbd5e1', 
        400: '#94a3b8',
        500: '#64748b',
        600: '#475569',
        700: '#334155',
        800: '#1e293b',
        900: '#0f172a'
      },
      accent: {
        50: '#fefce8',
        100: '#fef9c3',
        200: '#fef08a',
        300: '#fde047',
        400: '#facc15',
        500: '#eab308',  // Gul accent
        600: '#ca8a04',
        700: '#a16207',
        800: '#854d0e',
        900: '#713f12'
      },
      success: {
        50: '#f0fdf4',
        100: '#dcfce7',
        200: '#bbf7d0',
        300: '#86efac',
        400: '#4ade80',
        500: '#22c55e',
        600: '#16a34a',
        700: '#15803d',
        800: '#166534',
        900: '#14532d'
      },
      warning: {
        50: '#fffbeb',
        100: '#fef3c7',
        200: '#fde68a',
        300: '#fcd34d',
        400: '#fbbf24',
        500: '#f59e0b',
        600: '#d97706',
        700: '#b45309',
        800: '#92400e',
        900: '#78350f'
      },
      error: {
        50: '#fef2f2',
        100: '#fee2e2',
        200: '#fecaca',
        300: '#fca5a5',
        400: '#f87171',
        500: '#ef4444',
        600: '#dc2626',
        700: '#b91c1c',
        800: '#991b1b',
        900: '#7f1d1d'
      }
    }
  },

  // Energy tema (oransje/rød)
  energy: {
    name: 'Energi',
    description: 'Oransje og rød - varm og energisk',
    colors: {
      primary: {
        50: '#fff7ed',
        100: '#ffedd5',
        200: '#fed7aa',
        300: '#fdba74',
        400: '#fb923c',
        500: '#f97316',  // Oransje hovedfarge
        600: '#ea580c',
        700: '#c2410c',
        800: '#9a3412',
        900: '#7c2d12'
      },
      secondary: {
        50: '#f8fafc',
        100: '#f1f5f9',
        200: '#e2e8f0',
        300: '#cbd5e1', 
        400: '#94a3b8',
        500: '#64748b',
        600: '#475569',
        700: '#334155',
        800: '#1e293b',
        900: '#0f172a'
      },
      accent: {
        50: '#fef2f2',
        100: '#fee2e2',
        200: '#fecaca',
        300: '#fca5a5',
        400: '#f87171',
        500: '#ef4444',  // Rød accent
        600: '#dc2626',
        700: '#b91c1c',
        800: '#991b1b',
        900: '#7f1d1d'
      },
      success: {
        50: '#f0fdf4',
        100: '#dcfce7',
        200: '#bbf7d0',
        300: '#86efac',
        400: '#4ade80',
        500: '#22c55e',
        600: '#16a34a',
        700: '#15803d',
        800: '#166534',
        900: '#14532d'
      },
      warning: {
        50: '#fffbeb',
        100: '#fef3c7',
        200: '#fde68a',
        300: '#fcd34d',
        400: '#fbbf24',
        500: '#f59e0b',
        600: '#d97706',
        700: '#b45309',
        800: '#92400e',
        900: '#78350f'
      },
      error: {
        50: '#fef2f2',
        100: '#fee2e2',
        200: '#fecaca',
        300: '#fca5a5',
        400: '#f87171',
        500: '#ef4444',
        600: '#dc2626',
        700: '#b91c1c',
        800: '#991b1b',
        900: '#7f1d1d'
      }
    }
  },

  // NYTT: Nordic tema (dempet skandinavisk design)
  nordic: {
    name: 'Nordisk',
    description: 'Dempet og minimalistisk - skandinavisk design',
    colors: {
      primary: {
        50: '#f8fafc',  // Meget lys grå-blå
        100: '#f1f5f9',
        200: '#e2e8f0',
        300: '#cbd5e1',
        400: '#94a3b8',
        500: '#64748b',  // Dempet blå-grå som hovedfarge
        600: '#475569',
        700: '#334155',
        800: '#1e293b',
        900: '#0f172a'
      },
      secondary: {
        50: '#fafafa',  // Varm hvit
        100: '#f5f5f5',
        200: '#e5e5e5',
        300: '#d4d4d4',
        400: '#a3a3a3',
        500: '#737373',  // Varm grå
        600: '#525252',
        700: '#404040',
        800: '#262626',
        900: '#171717'
      },
      accent: {
        50: '#fef7ee',  // Varm lys oransje/fersken
        100: '#fed7aa',
        200: '#fed7aa',
        300: '#fdba74',
        400: '#fb923c',
        500: '#ea7a47',  // Varm terrakotta/rust
        600: '#dc6537',
        700: '#c2410c',
        800: '#9a3412',
        900: '#7c2d12'
      },
      success: {
        50: '#f0f9f0',  // Dempet grønn
        100: '#dcf4dc',
        200: '#bce8bc',
        300: '#8dd88d',
        400: '#5cb85c',
        500: '#4a9a4a',  // Mose-grønn
        600: '#3d813d',
        700: '#336633',
        800: '#2d4f2d',
        900: '#1a331a'
      },
      warning: {
        50: '#fffcf0',  // Varm gul som høstløv
        100: '#fff8dc',
        200: '#fff0b3',
        300: '#ffe680',
        400: '#ffdb4d',
        500: '#e6b800',  // Honning-gul
        600: '#cc9900',
        700: '#b37700',
        800: '#805500',
        900: '#4d3300'
      },
      error: {
        50: '#fdf5f3',  // Dempet rød som rødbrun
        100: '#fae8e3',
        200: '#f3cfc7',
        300: '#e8aca3',
        400: '#d97868',
        500: '#c45a47',  // Rust-rød
        600: '#a84732',
        700: '#8b3928',
        800: '#6f2e21',
        900: '#4d1f17'
      }
    }
  }
};

// Utility-funksjoner
export const getCurrentTheme = () => {
  const saved = localStorage.getItem('selectedTheme');
  return colorThemes[saved] || colorThemes.default;
};

export const getColor = (colorName, shade = 500) => {
  const theme = getCurrentTheme();
  return theme.colors[colorName]?.[shade] || theme.colors.primary[500];
};

// AUTOMATISK GENERERING AV CSS VARIABLER
export const injectCSSVariables = (themeName = 'default') => {
  const theme = colorThemes[themeName];
  if (!theme) return;

  const root = document.documentElement;
  
  // Fjern eksisterende CSS variabler først
  Array.from(root.style).forEach(prop => {
    if (prop.startsWith('--color-')) {
      root.style.removeProperty(prop);
    }
  });

  // Legg til nye CSS variabler
  Object.entries(theme.colors).forEach(([colorName, shades]) => {
    Object.entries(shades).forEach(([shade, value]) => {
      root.style.setProperty(`--color-${colorName}-${shade}`, value);
    });
  });

  // Legg til computed gradients
  const primary500 = theme.colors.primary[500];
  const primary600 = theme.colors.primary[600];
  const accent500 = theme.colors.accent[500];
  const accent600 = theme.colors.accent[600];

  root.style.setProperty('--gradient-primary', `linear-gradient(135deg, ${primary500}, ${primary600})`);
  root.style.setProperty('--gradient-accent', `linear-gradient(135deg, ${accent500}, ${accent600})`);
  root.style.setProperty('--gradient-hero', `linear-gradient(135deg, ${primary500}, ${accent500})`);
  
  // Legg til shadows
  root.style.setProperty('--shadow-primary', `0 4px 14px 0 ${primary500}30`);
  root.style.setProperty('--shadow-accent', `0 4px 14px 0 ${accent500}30`);
  
  // Debug: Console log for å sjekke at CSS-variabler settes
  console.log(`🎨 Tema endret til: ${theme.name}`);
  console.log(`Primary: ${primary500}, Accent: ${accent500}`);
};

// AUTOMATISK GENERERING AV TAILWIND CONFIG
export const generateTailwindColors = (themeName = 'default') => {
  const theme = colorThemes[themeName];
  if (!theme) return {};

  return {
    // Custom farger
    primary: theme.colors.primary,
    secondary: theme.colors.secondary,
    accent: theme.colors.accent,
    success: theme.colors.success,
    warning: theme.colors.warning,
    error: theme.colors.error,
    
    // Override standard Tailwind farger
    pink: theme.colors.primary,     // pink-500 blir primary-500
    blue: theme.colors.accent,      // blue-500 blir accent-500  
    gray: theme.colors.secondary,   // gray-500 blir secondary-500
    green: theme.colors.success,    // green-500 blir success-500
    yellow: theme.colors.warning,   // yellow-500 blir warning-500
    red: theme.colors.error         // red-500 blir error-500
  };
};

export default colorThemes;